import { useMutation, useQueryClient } from 'react-query';

import {
  CURRENT_USER_KEY,
  SanitizedUserParams,
  updateCurrentUser,
} from '@utils/backend-api/currentUser';

export default function useCurrentUserUpdate() {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isLoading } = useMutation(
    (values: SanitizedUserParams) => updateCurrentUser(values),
    {
      onSuccess: (data) => {
        queryClient.setQueryData([CURRENT_USER_KEY], data?.user);
      },
    }
  );

  return {
    updateCurrentUser: mutate,
    updateCurrentUserAsync: mutateAsync,
    isLoadingUpdate: isLoading,
  };
}
